export default __webpack_public_path__ + "static/media/work-four.47a0a397.PNG";